//
//
//
//
//
//
//

import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "MatrixWysiwyg",
	props: ["value"],
	components: {
		matrixWysiwyg: CKEditor.component
	},
  data() {
    return {
      editor: ClassicEditor,
      editorData: null,
      editorConfig: {
				fontSize: 'small',
        toolbar: {
          items: [
            "bold",
            "italic",
            "link",
            "|",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "undo",
            "redo"
          ]
        }
      }
    };
  },
  watch: {
    editorData() {
      this.$emit("input", this.editorData);
    }
  },
  created() {
    this.editorData = this.value;
  }
};
